import { render, staticRenderFns } from "./diyBoard.vue?vue&type=template&id=18bf6f28&scoped=true&"
import script from "./diyBoard.vue?vue&type=script&lang=js&"
export * from "./diyBoard.vue?vue&type=script&lang=js&"
import style0 from "./diyBoard.vue?vue&type=style&index=0&id=18bf6f28&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf6f28",
  null
  
)

export default component.exports